// extracted by mini-css-extract-plugin
export default {"control":"tooltip_control__5Lo0J","content":"tooltip_content__i8ShI"};